module.exports = __webpack_public_path__ + "static/media/finance-analytics.ad4b8618.svg";